export default __webpack_public_path__ + "static/media/about-hero-right.534fc28b.png";